import { DialpadSharp } from "@material-ui/icons";
import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";
import {
  getPortalMessageCacheSection,
  setPortalMessageCacheSection,
} from "../utils/portalMessageCache";

export const selectClassSlice = createSlice({
  name: "selectClassSlice",
  initialState: {
    selectClassData: [],
    terms: [],
    classDataFromAPI: [],
    studentRegisterAPI: [],
    classCourseDataFromAPI: [],
    modalData: [],
    selectedClassData: [],
    txnDetails: {},
    sessionCalender: [],
    price: 0,
    euroPrice: 0,
    paymentResponse: "",
    errorMessage: undefined,
    dataFetchingStatus: false,
    errorStatusCode: undefined,
    validationCheckFailed: [],
    corequisitevalidationCheckFailed: [],
    timeConflictvalidationCheckFailed: [],
    multipleTimeConflictvalidationCheckFailed: [],
    prerequisitesError:{},
    enrolledSessions:[],
    noticeData:[],
    dscErrorMessage: false,
    currentStudent:{}
  },

  reducers: {
    setSelectclassData: (state, action) => {
      state.selectClassData.push(action.payload);
    },
    setDSCErrorMessage:(state, action) => {
      state.dscErrorMessage = action.payload;
    },
    setPaymentResponse: (state, action) => {
      state.paymentResponse = action.payload;
    },
    setSelectclassDataAfterModify: (state, action) => {
      state.selectClassData = action.payload;
    },
    setTxnDetails: (state, action) => {
      state.txnDetails = action.payload;
    },
    setPrice: (state, action) => {
      state.price = action.payload;
    },
    setSessionCalender: (state, action) => {
      state.sessionCalender = action.payload;
    },
    setValidationCheckFailed: (state, action) => {
      state.validationCheckFailed = action.payload;
    },
    setCorequisiteValidationCheckFailed: (state, action) => {
      state.corequisitevalidationCheckFailed = action.payload;
    },
    setEnrolledSessions: (state, action) => {
      state.enrolledSessions = action.payload;
    },
    setTimeConflictValidationCheckFailed: (state, action) => {
      state.timeConflictvalidationCheckFailed = action.payload;
    },
    setMultipleTimeConflictValidationCheckFailed: (state, action) => {
      state.multipleTimeConflictvalidationCheckFailed = action.payload;
    },
    setPrerequisitesError:(state, action) => {
      state.prerequisitesError = action.payload;
    },
    setWebSelectclassData: (state, action) => {
      state.classDataFromAPI = action.payload;
    },
    setStudentRegisterData: (state, action) => {
      state.studentRegisterAPI = action.payload;
    },
    setWebSelectclassCourseData: (state, action) => {
      state.classCourseDataFromAPI = action.payload;
    },
    setTermsData: (state, action) => {
      state.terms = action.payload;
    },
    setModalData: (state, action) => {
      state.modalData = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setErrorStatusCode: (state, action) => {
      state.errorStatusCode = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
    removeElementsFromArray: (state, action) => {
      state.selectClassData = action.payload;
    },
    removeWebSelectclassData: (state, action) => {
      state.classDataFromAPI = action.payload;
    },
    removeWebSelectclassCourseData: (state, action) => {
      state.classCourseDataFromAPI = action.payload;
    },
    removeModalSelectclassData: (state, action) => {
      state.modalData = action.payload;
    },
    removeTxnDetails: (state, action) => {
      state.txnDetails = action.payload;
    },
    clearPaymentResponse: (state, action) => {
      state.paymentResponse = action.payload;
    },
    setNoticeData: (state, action) => {
      state.noticeData = action.payload;
    },
    setCurrentStudent: (state, action) => {
      state.currentStudent = action.payload;
    },
  },
});

export const {
  setSelectclassData,
  setSelectclassDataAfterModify,
  setDSCErrorMessage,
  setWebSelectclassData,
  setStudentRegisterData,
  setWebSelectclassCourseData,
  setErrorMessage,
  setModalData,
  setErrorStatusCode,
  setDataFetchingStatus,
  removeElementsFromArray,
  setTermsData,
  setPrice,
  setSessionCalender,
  setValidationCheckFailed,
  setCorequisiteValidationCheckFailed,
  setEnrolledSessions,
  setTimeConflictValidationCheckFailed,
  setMultipleTimeConflictValidationCheckFailed,
  setPrerequisitesError,
  removeWebSelectclassData,
  removeWebSelectclassCourseData,
  removeModalSelectclassData,
  setPaymentResponse,
  clearPaymentResponse,
  removeTxnDetails,
  setTxnDetails,
  setNoticeData,
  setCurrentStudent,
} = selectClassSlice.actions;

export const getSelectClassDataFromAPI =
  (degreeId, currentDateTime) => (dispatch) => {
    dispatch(removeWebSelectclassData([]));
    dispatch(removeElementsFromArray([]));
    dispatch(setDataFetchingStatus(true));
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + window.localStorage.getItem("x-auth-token");
    axios
      .get(
        `students/select-class?degreeId=${degreeId}&currentDateTime=${currentDateTime}`,
      )
      .then((response) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setWebSelectclassData(response.data.data.Data));
      })
      .catch((error) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setErrorMessage(error.response.data.error));
        dispatch(setErrorStatusCode(error.response.status));
      });
  };

export const getStudentRegisterAPI = (studentId) => (dispatch) => {
  dispatch(removeWebSelectclassData([]));
  dispatch(removeElementsFromArray([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`students/select-class/usbregister?studentId=${studentId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setStudentRegisterData(response.data.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getSelectClassCourseDataFromAPI = (studentId) => (dispatch) => {
  dispatch(removeWebSelectclassCourseData([]));
  dispatch(removeElementsFromArray([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`students/select-class/courseCatalog?studentId=${studentId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setWebSelectclassCourseData(response.data.data.Data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getTxnDetails = (data) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  // dispatch(removeTxnDetails({}));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`/application/payment-request/vapulus/${data}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setTxnDetails(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const paymentRequest = (data) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(clearPaymentResponse(""));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post(`students/select-class/payment-request`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setPaymentResponse(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
// export const updateParmsForClass = (data) => (dispatch) => {
//   dispatch(setDataFetchingStatus(true));
//   axios.defaults.headers.common["Authorization"] =
//     "Bearer " + window.localStorage.getItem("x-auth-token");
//   axios
//     .post(`class/update`, data)
//     .then((response) => {
//       dispatch(setDataFetchingStatus(false));
//       dispatch(setErrorMessage(response.data.message));
//     })
//     .catch((error) => {
//       dispatch(setDataFetchingStatus(false));
//       dispatch(setErrorMessage(error.response.data.error));
//       dispatch(setErrorStatusCode(error.response.status));
//     });
// };
// export const getTermData = () => (dispatch) => {
//   dispatch(removeElementsFromArray([]));
//   dispatch(setDataFetchingStatus(true));
//   axios.defaults.headers.common["Authorization"] =
//     "Bearer " + window.localStorage.getItem("x-auth-token");
//   axios
//     .get(`class/classes/getTerms`)
//     .then((response) => {
//       // dispatch(setDataFetchingStatus(false));
//       dispatch(setTermsData(response.data));
//     })
//     .catch((error) => {
//       // dispatch(setDataFetchingStatus(false));
//       dispatch(setErrorMessage(error.response.data.error));
//       dispatch(setErrorStatusCode(error.response.status));
//     });
// };
export const clearSelectClassData = () => (dispatch) => {
  dispatch(removeElementsFromArray([]));
};
export const addSelectClassData = (classData) => (dispatch) => {
  dispatch(setSelectclassData(classData));
};
export const setDuplicateSelectClassMessage = () => (dispatch) => {
  dispatch(setDSCErrorMessage(true));
};
export const clearDuplicateSelectClassMessage = () => (dispatch) => {
  dispatch(setDSCErrorMessage(false));
};
export const addSelectModalData = (classData) => (dispatch) => {
  dispatch(removeModalSelectclassData([]));
  dispatch(setModalData(classData));
};

export const clearErrorStatusCode = () => (dispatch) => {
  dispatch(setErrorStatusCode(undefined));
};
export const clearErrorMessage = () => (dispatch) => {
  dispatch(setErrorMessage(undefined));
};

export const removeParticularModalData = (data) => (dispatch) => {
  dispatch(setSelectclassDataAfterModify(data));
};
export const updatePrice = (price) => (dispatch) => {
  dispatch(setPrice(price));
};
export const clearValidationCheck = () => (dispatch) => {
  dispatch(setValidationCheckFailed([]));
};
export const clearCorequisiteValidationCheck = () => (dispatch) => {
  dispatch(setCorequisiteValidationCheckFailed([]));
};
export const clearTimeConflictValidationCheck = () => (dispatch) => {
  dispatch(setTimeConflictValidationCheckFailed([]));
};
export const clearEnrolledSessions = () => (dispatch) => {
  dispatch(setEnrolledSessions([]));
};
export const clearMultipleTimeConflictValidationCheck = () => (dispatch) => {
  dispatch(setMultipleTimeConflictValidationCheckFailed([]));
};
export const clearPrerequisitesError = () => (dispatch) => {
  dispatch(setPrerequisitesError({}));
};

export const SaveSelectedClassDetails = (data) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(clearPaymentResponse(""));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post(`students/select-class/save-class-details`, data)
    .then((response) => {
      if (response?.data?.enrolledSessions?.length > 0) {
        dispatch(
          setEnrolledSessions(response?.data?.enrolledSessions),
        );
      } else if (response.data.status === 400) {
        dispatch(setDataFetchingStatus(false));
        dispatch(removeWebSelectclassData([]));
        return dispatch(
          setPrerequisitesError(response.data.data),
        );
      } else if (
        response?.data?.validationcheck?.length > 0 &&
        response?.data?.corequisite?.length > 0 &&
        response?.data?.timeConflict?.length > 0
      ) {
        dispatch(setValidationCheckFailed(response?.data?.validationcheck));
        dispatch(
          setCorequisiteValidationCheckFailed(response?.data?.corequisite),
        );
        dispatch(
          setTimeConflictValidationCheckFailed(response?.data?.timeConflict),
        );
      } else if (response?.data?.validationcheck?.length > 0) {
        dispatch(setValidationCheckFailed(response?.data?.validationcheck));
      } else if (response?.data?.corequisite?.length > 0) {
        dispatch(
          setCorequisiteValidationCheckFailed(response?.data?.corequisite),
        );
      } 
      if (response?.data?.timeConflict?.length > 0) {
        dispatch(
          setTimeConflictValidationCheckFailed(response?.data?.timeConflict),
        );
      } else if (response?.data?.multipleTimeConflicts?.length > 0) {
        dispatch(
          setMultipleTimeConflictValidationCheckFailed(response?.data?.multipleTimeConflicts),
        );
      }  else {
        dispatch(setErrorMessage(response.data.message));
      }
      dispatch(setDataFetchingStatus(false));
      dispatch(removeWebSelectclassData([]));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.message));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getSessionCalender = (studentId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`/students/sessioncalender/${studentId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setSessionCalender(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getNoticeDetails =
  (studentId, contactId, options = {}) =>
  (dispatch) => {
    const { force = false } = options;
    const cachedNotices = getPortalMessageCacheSection("classSelection");

    if (
      !force &&
      cachedNotices &&
      cachedNotices.studentId === studentId &&
      cachedNotices.contactId === contactId
    ) {
      dispatch(setNoticeData(cachedNotices.notices || []));
      if (cachedNotices.currentStudent) {
        dispatch(setCurrentStudent(cachedNotices.currentStudent));
      }
      return Promise.resolve(cachedNotices.notices || []);
    }

    dispatch(setDataFetchingStatus(true));
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + window.localStorage.getItem("x-auth-token");
    return axios
      .get(`/notice/${studentId}/${contactId}`)
      .then((response) => {
        dispatch(setDataFetchingStatus(false));
        const notices = response.data?.notices || [];
        const currentStudent = response.data?.contacts?.[0] || {};
        dispatch(setNoticeData(notices));
        if (Object.keys(currentStudent).length > 0) {
          dispatch(setCurrentStudent(currentStudent));
        }
        setPortalMessageCacheSection("classSelection", {
          studentId,
          contactId,
          notices,
          currentStudent,
        });
        return notices;
      })
      .catch((error) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setErrorMessage(error.response.data.error));
        dispatch(setErrorStatusCode(error.response.status));
        throw error;
      });
  };


export default selectClassSlice.reducer;
